import { T }                      from 'defa-object';
import ControlModuleErrorView     from 'scripts/defa/basic/view-control-module-error-view';
import ErrorView                  from 'scripts/defa/basic/view-error-view';
import SettingsHome               from 'scripts/defa/settings-home/model-settings-home';
import MasterControl              from 'scripts/defa/unit-feature-sets/endpoints/homeAutomation/model-master-control';
import PowerConfiguration
								  from 'scripts/defa/unit-feature-sets/endpoints/homeAutomation/model-power-configuration';
import IasZone                    from 'scripts/defa/unit-feature-sets/endpoints/wiredAlarmInput/model-iasZone';
import UnitTechnical              from 'scripts/defa/unit-technicals/model-unit-technical';
import Container                  from 'scripts/poppet/container';
import template                   from 'templates/controlContainer.jst.html';
import { Vue }                    from 'vue/defavue';
import ControlAccessoriesView     from './accessories-holder/view-control-accessories-view';
import ControlCalendarEntriesView from './calendar/view-control-calendar-entries-view';
import ControlDayAndNightView     from './day-and-night/view-control-day-and-night-view';
import ControlDigiHeatView        from './digiheat/view-digiheat-view';
import ControlGpaiView            from './general-alarm-switches/view-control-gpai';
import ControlGenericStatesView   from './generic-state/view-control-generic-states-view';
import ControlHomeAlertsView      from './home-alerts/view-control-home-alerts-view';
import ControlSwitchesView        from './home-main-switches/view-control-switches-view';
import ControlFinderView          from './map/view-control-finder-view';
import ControlNoteView            from './note/view-control-note-view';
import ControlNotificationsView   from './notification-holders/view-control-notifications-view';
import ControlPickupTimesView     from './pickup-times/view-control-pickup-times-view';
import ControlSecurityView        from './security/control-security-view';
import ControlAlarmView           from './view-control-alarm-view';
import ControlDetailsView         from './view-control-details-view';
import ControlMapView             from './view-control-map-view';
import ControlSettingsView        from './view-control-settings-view';
import ControlTechnicalView       from './view-control-technical-view';
import ControlWeatherView         from './view-control-weather-view';
import ControlZonesView           from './view-control-zones-view';
import ControlGeneralHomeView     from './warmup-settings/view-control-general-home-view';
import ControlWarmupStatesView    from './warmup-state/view-control-warmup-states-view';
import UnitUserAccess             from 'scripts/defa/access-handler/unit-user-access';

/**
 * defa.views.ControlContainer
 * A container for all unit control functionality.
 * @version 1.2.0
 */

const channelUser = Bb.Radio.channel( 'user' ),
	  channel     = Bb.Radio.channel('objects');

const selectors = {
	regionAccessories  : '[data-region=control-accessories]',
	regionError        : '[data-region=control-error]',
	regionProgress     : '[data-region=control-progress]',
	refreshButton      : '[data-click=refresh]',
	regionGeneral      : '[data-region=control-general]',
	regionSwitches     : '[data-region=control-switches]',
	regionZones        : '[data-region=control-zones]',
	regionAlarm        : '[data-region=control-alarm]',
	regionNotifications: '[data-region=control-notifications]',
	regionPickupTimes  : '[data-region=control-pickup-times]',
	regionCalendar     : '[data-region=control-calendar]',
	regionDayAndNight  : '[data-region=control-day-and-night]',
	regionDigiHeat     : '[data-region=control-digiheat]',
	regionFinder       : '[data-region=control-finder]',
	regionGeneralAlarms: '[data-region=control-general-alarm-input]',
	regionGenericStates: '[data-region=control-generic-states]',
	regionHomeAlert    : '[data-region=control-home-alerts]',
	regionMap          : '[data-region=control-map]',
	regionNotes        : '[data-region=control-note]',
	regionWeather      : '[data-region=control-weather]',
	regionDetails      : '[data-region=control-details]',
	regionTechnical    : '[data-region=control-technical]',
	regionSettings     : '[data-region=control-settings]',
	regionWarmupStates : '[data-region=control-warmup-states]',
	security           : '[data-region=control-security]',
};

const ControlContainer = Container.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	className: 'control-container',
	
	regions: {
		accessories  : selectors.regionAccessories,
		error        : selectors.regionError,
		progress     : selectors.regionProgress,
		general      : selectors.regionGeneral,
		switches     : selectors.regionSwitches,
		zones        : selectors.regionZones,
		alarm        : selectors.regionAlarm,
		notifications: selectors.regionNotifications,
		pickupTimes  : selectors.regionPickupTimes,
		calendar     : selectors.regionCalendar,
		dayAndNight  : selectors.regionDayAndNight,
		digiHeat     : selectors.regionDigiHeat,
		finder       : selectors.regionFinder,
		homeAlerts   : selectors.regionHomeAlert,
		generalAlarms: selectors.regionGeneralAlarms,
		genericStates: selectors.regionGenericStates,
		map          : selectors.regionMap,
		notes        : selectors.regionNotes,
		details      : selectors.regionDetails,
		technical    : selectors.regionTechnical,
		security 	 : selectors.security,
		settings     : selectors.regionSettings,
		weather      : selectors.regionWeather,
		warmupStates : selectors.regionWarmupStates,
	},
	
	ui: {
		refresh      : selectors.refreshButton,
		accessories  : selectors.regionAccessories,
		error        : selectors.regionError,
		progress     : selectors.regionProgress,
		general      : selectors.regionGeneral,
		switches     : selectors.regionSwitches,
		zones        : selectors.regionZones,
		alarm        : selectors.regionAlarm,
		notifications: selectors.regionNotifications,
		pickupTimes  : selectors.regionPickupTimes,
		calendar     : selectors.regionCalendar,
		dayAndNight  : selectors.regionDayAndNight,
		digiHeat     : selectors.regionDigiHeat,
		finder       : selectors.regionFinder,
		homeAlerts   : selectors.regionHomeAlert,
		generalAlarms: selectors.regionGeneralAlarms,
		genericStates: selectors.regionGenericStates,
		map          : selectors.regionMap,
		notes        : selectors.regionNotes,
		details      : selectors.regionDetails,
		technical    : selectors.regionTechnical,
		security 	 : selectors.security,
		settings     : selectors.regionSettings,
		weather      : selectors.regionWeather,
		warmupStates : selectors.regionWarmupStates,
	},

	events: {
		'click @ui.refresh': 'onClickRefresh',
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	onDomRefresh() {
		let self   = this;
		
		new Vue ({
			el: '#is-configuring-info',
			bb() {
				return {
					model: self.options.unit,
				};
			},
			computed: {
				isConfiguring: function() {
					return this.model.transientIsConfiguring;
				}
			}
			
		});
	},
	
	/**
	 * Triggers when a child view triggers 'upgrade'.
	 * @void
	 */
	onChildviewUpgrade: function ( childView ) {
		this.trigger('upgrade', childView);
	},

	onClickRefresh: function() {
		this._refreshCommunicationModules();
	},

	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	// - order of operations
	
	/**
	 * Initializes subviews, triggered on onRender and when settings change.
	 * @void
	 * When refreshing the page, this method is triggered twice. First when
	 * the view is created and the nonCommunication models have been fetched.
	 * Then it is triggered again after the featureSet is fetched and the settings change.
	 */
	attachView: function () {
		if(this.options.featureSet && this.options.featureSet.id === this.options.unit.id) {
			this.ui.refresh.removeClass( 'hidden' );
			if ( !this.options.featureSet.useBackendApi() ) {
				this.ui.refresh.addClass( 'hidden' );
			}
			if ( this.options.featureSetFailed ) {
				let errorView = new ErrorView( { title: T.tc( 'Error', 'Failed to fetch unit endpoints' ), message: this.options.featureSetResponse.message } );
				this.showChildView( 'error', errorView );
			} else {
				this.detachChildView('progress');
				this.detachChildView( 'error' );
				this._updateCommunicationModules();
				this._attachCommunicationModules();
			}
			
		}else{
			if(UnitUserAccess.hasUnitControlAccess(this.options.unit, this.options.user)){
				this.showProgressBar();
			}
			this.ui.refresh.addClass( 'hidden' );
		}
		
		if(this.options.unit){
			this.updateNonCommunicationModules();
			this._attachNonCommunicationModules();
		}
		this.stopListening(this.options.featureSet, 'change');
		this.listenTo(this.options.featureSet, 'change', this._onFeatureSetChanged);
	},

	/**
	* If FeatureSet changed after view has been loaded, toggle views.
	* (This feature is mainly for Native App)
	*/
	_onFeatureSetChanged: function() {
		if(this.communicationModules.hasGeneral && !this.options.featureSet.hasWarmUp()) {
			this.detachChildView('general');
		} else if(!this.communicationModules.hasGeneral && this.options.featureSet.hasWarmUp()) {
			this._showGeneral();
		}
		
		if(this.communicationModules.hasPickupTimes && !this.options.featureSet.hasPickupTimes()) {
			this.detachChildView('pickupTimes');
		} else if(!this.communicationModules.hasPickupTimes && this.options.featureSet.hasPickupTimes()) {
			this._showPickupTimes();
		}

		if(this.communicationModules.hasNotifications && !this.options.featureSet.hasNotifications()) {
			this.detachChildView('notifications');
		} else if(!this.communicationModules.hasNotifications && this.options.featureSet.hasNotifications()) {
			this._showNotifications();
		}

		if(this.communicationModules.hasCalendar && !this.options.featureSet.hasCalendar()) {
			this.detachChildView('calendar');
		} else if(!this.communicationModules.hasCalendar && this.options.featureSet.hasCalendar()) {
			this._showCalendar();
		}

		if(this.communicationModules.hasAccessories && !this.options.featureSet.hasAccessories()) {
			this.detachChildView('accessories');
		} else if(!this.communicationModules.hasAccessories && this.options.featureSet.hasAccessories()) {
			this._showAccessories();
		}

		if(this.communicationModules.hasWarmupStates && !this.options.featureSet.hasWarmupStates()) {
			this.detachChildView('warmupStates');
		} else if(!this.communicationModules.hasWarmupStates && this.options.featureSet.hasWarmupStates()) {
			this._showWarmupStates();
		}
		
		if(this.communicationModules.hasSettings && !this.options.featureSet.hasSettings()) {
			this.detachChildView('settings');
		} else if(!this.communicationModules.hasSettings && this.options.featureSet.hasSettings()) {
			this._showSettings();
		}
		
		if(this.communicationModules.hasGenericStates && !this.options.featureSet.hasGenericStates()) {
			this.detachChildView('genericStates');
		} else if (!this.communicationModules.hasGenericStates && this.options.featureSet.hasGenericStates()) {
			this._showGenericStates();
		}

		if(this.communicationModules.hasSecurity && !this.options.featureSet.hasSecurity()){
			this.detachChildView('security');
		} else if(!this.communicationModules.hasSecurity && this.options.featureSet.hasSecurity()){
			this._showSecurity();
		}
		
		if(this.communicationModules.hasHomeAlerts && !(this.options.featureSet.hasTemperatureAlert() ||
		                                   this.options.featureSet.hasBatteryAlert() ||
		                                   this.options.featureSet.hasPowerAlert())) {
			this.detachChildView('homeAlerts');
		} else if (!this.communicationModules.hasHomeAlerts && (this.options.featureSet.hasTemperatureAlert() ||
		                                           this.options.featureSet.hasBatteryAlert() ||
		                                           this.options.featureSet.hasPowerAlert())) {
			this._showHomeAlerts();
		}

		if(this.communicationModules.hasDayAndNight && !this.options.featureSet.hasDayAndNight()) {
			this.detachChildView('dayAndNight');
		} else if(!this.communicationModules.hasDayAndNight && this.options.featureSet.hasDayAndNight()) {
			this._showDayAndNight();
		}

		if(this.communicationModules.hasDigiHeat && !this.options.featureSet.hasDigiHeat()) {
			this.detachChildView('digiHeat');
		} else if(!this.communicationModules.hasDigiHeat && this.options.featureSet.hasDigiHeat()) {
			this._showDigiHeat();
		}

		if( !this.options.featureSet.useBackendApi() && !this.ui.refresh.hasClass('hidden') ) {
			this.ui.refresh.addClass('hidden');
		} else if ( this.options.featureSet.useBackendApi() && this.ui.refresh.hasClass('hidden') ) {
			this.ui.refresh.remove( 'hidden' );
		}

		this._updateCommunicationModules();
	},
	
	_updateCommunicationModules: function () {
		
		this.communicationModules = {
			hasAccessories  : this.options.featureSet.hasAccessories(),
			hasGeneral      : this.options.featureSet.hasWarmUp(),
			hasSwitches     : this.options.featureSet.hasHeatingSwitch() ||
							  this.options.featureSet.hasAlarmSwitch(),
			hasZones        : this.options.featureSet.hasZones(),
			hasAlarm        : this.options.featureSet.hasAlarm(),
			hasPickupTimes  : this.options.featureSet.hasPickupTimes(),
			hasCalendar     : this.options.featureSet.hasCalendar(),
			hasSecurity     : this.options.featureSet.hasSecurity(),
			hasFinder       : this.options.featureSet.hasFinder(),
			hasWarmupStates : this.options.featureSet.hasWarmupStates(),
			hasGenericStates: this.options.featureSet.hasGenericStates(),
			hasHomeAlerts   : this.options.featureSet.hasTemperatureAlert() ||
							  this.options.featureSet.hasBatteryAlert() ||
							  this.options.featureSet.hasPowerAlert(),
			hasDayAndNight  : this.options.featureSet.hasDayAndNight(),
			hasDigiHeat     : this.options.featureSet.hasDigiHeat(),
			hasGeneralAlarms: this.options.featureSet.hasGeneralAlarmInputSwitch() ||
							  this.options.featureSet.hasFollowMainAlarmSwitch(),
		};
	},
	
	
	updateNonCommunicationModules: function(){
		this.nonCommunicationModules = {
			hasWeather      : this.model.isHome() && UnitUserAccess.hasUnitControlAccess(this.options.unit, this.options.user),
			hasNotifications: this.options.notificationHolderModel,
			//hasMap          : this.options.featureSet.hasMap(),
			// !TODO This map should only be shown for DT50 units
			hasDetails      : false,
			hasTechnical    : channelUser.request( 'is:techsupport' ),
			hasSettings     : true,
			hasNotes        : this.options.unit.get('notes') != undefined && UnitUserAccess.hasUnitControlAccess(this.options.unit, this.options.user),
		};
	},

	/**
	 * Refresh models for communcation modules ( modules that communicates with the unit )
	 * Note: Notifications are included here, as it is considered as indirect unit communication
	 * @private
	 * @void
	 */
	_refreshCommunicationModules: function() {
		let id = this.options.unit.get('id');
		if(this.options.featureSetFailed) {
			this.options.featureSet.trigger('refresh', this);
			this.detachChildView('error');
			this.showProgressBar();
			
		}else{
			
			if ( this.communicationModules.hasGeneral ) {
				let warmupModel = channel.request( 'warmups' ).get( id );
				if ( !warmupModel ) {
					console.warn( 'Could not find warmupModel' );
				} else {
					warmupModel.refresh();
				}
			}
			
			if ( this.communicationModules.hasFinder ) {
				if ( !this.options.finderModel ) {
					console.warn( 'Could not find finderModel' );
				} else {
					this.options.finderModel.refresh();
				}
			}
			
			if ( this.communicationModules.hasZones ) {
				if ( !this.options.zoneHolderModel ) {
					console.warn( 'Could not find zoneHolderModel' );
				} else {
					this.options.zoneHolderModel.refresh();
				}
			}
			
			if ( this.communicationModules.hasDigiHeat ) {
				if ( !this.options.digiHeatModel ) {
					console.warn( 'Could not find digiHeatModel' );
				} else {
					this.options.digiHeatModel.refresh();
				}
			}
			
			if ( this.communicationModules.hasGenericStates ) {
				if ( !this.options.genericStateModel ) {
					console.warn( 'Could not find genericStateModel' );
				} else {
					this.options.genericStateModel.refresh();
				}
			}
			
			if ( this.communicationModules.hasAccessories ) {
				if ( !this.options.accessoriesHolderModel ) {
					console.warn( 'Could not find accessoryModel' );
				} else {
					this.options.accessoriesHolderModel.refresh();
				}
			}
			
			if ( this.communicationModules.hasSwitches ||
				 this.communicationModules.hasCalendar ||
				 this.communicationModules.hasDayAndNight ||
				 this.communicationModules.hasHomeAlerts ) {
				new MasterControl( { id: this.options.unit.get( 'id' ) } ).refresh();
			}
			
			if ( this.communicationModules.hasHomeAlerts ) {
				new PowerConfiguration( { id: this.options.unit.get( 'id' ) } ).refresh();
			}
			
			if ( this.communicationModules.hasGeneralAlarms ) {
				new IasZone( { id: this.options.unit.get( 'id' ) } ).refresh();
			}
			
			if ( this.communicationModules.hasSecurity ) {
				if ( !this.options.securityModel ) {
					console.warn( 'Could not find securityModel' );
				} else {
					this.options.securityModel.refresh();
				}
			}
		}
		this.ui.refresh.removeClass('disabled');
	},
	
	/**
	 * Attaches modules for this unit.
	 * @private
	 * @void
	 */
	_attachCommunicationModules: function () {
		this.emptyCommunicationRegions();
		if ( this.communicationModules.hasHomeAlerts && 'control:alarmSettings' === this.options.subView) {
			this._showHomeAlerts();
		}
		if ( this.communicationModules.hasDayAndNight && 'control:dayAndNight' === this.options.subView) {
			this._showDayAndNight();
		}
		if ( this.communicationModules.hasGeneralAlarms && 'control:gpai' === this.options.subView) {
			this._showGeneralAlarmInputs();
		}
		if( !this.isSettingModule()) {
			
			if ( this.communicationModules.hasGeneral ) {
				this._showGeneral();
			}
			
			if ( this.communicationModules.hasSwitches ) {
				this._showSwitches();
			}
			
			if ( this.communicationModules.hasZones ) {
				this._showZones();
			}
			
			if ( this.communicationModules.hasAlarm ) {
				this._showAlarm();
			}
			
			if ( this.communicationModules.hasPickupTimes ) {
				this._showPickupTimes();
			}
			
			if ( this.communicationModules.hasCalendar ) {
				this._showCalendar();
			}
			if ( this.communicationModules.hasSecurity ) {
				this._showSecurity();
			}
			
			if ( this.communicationModules.hasFinder ) {
				this._showFinder();
			}
			if ( this.communicationModules.hasWarmupStates ) {
				this._showWarmupStates();
			}
			
			if ( this.communicationModules.hasGenericStates ) {
				this._showGenericStates();
			}
			
			if ( this.communicationModules.hasAccessories ) {
				this._showAccessories();
			}
			
			if ( this.communicationModules.hasDigiHeat ) {
				this._showDigiHeat();
			}
		}
	},
	
	_attachNonCommunicationModules: function(){
		this.emptyNonCommunicationRegions()
		if ( !this.isSettingModule()) {
			if ( this.nonCommunicationModules.hasNotes ) {
				this._showNotes();
			}
			if ( this.nonCommunicationModules.hasNotifications ) {
				this._showNotifications();
			}
			if ( this.nonCommunicationModules.hasWeather ) {
				this._showWeather();
			}
			if ( this.nonCommunicationModules.hasMap ) {
				this._showMap();
			}
			if ( this.nonCommunicationModules.hasDetails ) {
				this._showDetails();
			}
			if ( this.nonCommunicationModules.hasTechnical ) {
				this._showTechnical();
			}
			if ( this.nonCommunicationModules.hasSettings ) {
				this._showSettings();
			}
		}
	},
	
	/**
	 * Finds the current correct state for a module based on the subView.
	 * @private
	 * @param module {string}  The current module name.
	 * @return {string}  One of three valid module states: "open", "closed" or "hidden".
	 */
	_getModuleState: function ( module ) {
		
		// strip control prefix from subView and match with the input.
		let state    = '',
			leadView = this.options.subView.replace( 'control:', '' );
		
		if ( 'overview' === leadView ) {
			state = 'closed';
		} else {
			if ( leadView === module ) {
				state = 'open';
			} else {
				state = 'hidden';
			}
		}
		
		return state;
	},
	
	
	// -- show modules
	
	/**
	 * Creates and attaches the general home module.
	 * @private
	 * @void
	 */
	_showGeneral: function () {
		
		let controlGeneralHomeView = new ControlGeneralHomeView( _.extend( this.options, {
			model: this.options.warmupSettingModel || channel.request( 'warmupSettings').get( this.options.unit.get('id')),
		} ) );

		this.showChildView( 'general', controlGeneralHomeView );
	},
	
	_showSwitches: function () {
		
		let controlSwitchesView = new ControlSwitchesView( _.extend( this.options, {
			settingsHome : channel.request('settingsHomes').get(this.options.unit.get('transientSettingsHome')) || new SettingsHome( {unit : this.options.unit.get('id')} ),
			model: {
				heatingModel: (this.options.heatingSwitchModel || channel.request( 'heatingSwitchs').get( this.options.unit.get('id'))),
				alarmModel : (this.options.alarmSwitchModel || channel.request( 'alarmSwitchs').get( this.options.unit.get('id'))),
			}
		} ) );
		this.showChildView( 'switches', controlSwitchesView );
	},

	/**
	 * Creates and attaches the zones module.
	 * @private
	 * @void
	 */
	_showZones: function () {
		let controlZonesView = new ControlZonesView( _.extend( this.options, {
			model: this.options.zoneHolderModel,
			state: this._getModuleState( 'zones' ),
			settingsHome : channel.request('settingsHomes').get(this.options.unit.get('transientSettingsHome')) || new SettingsHome( {unit: this.options.unit.get('id')} )
		} ) );
		
		this.showChildView( 'zones', controlZonesView );
		
	},

	/**
	 * Creates and attaches the digiheat module.
	 * @private
	 * @void
	 */
	_showDigiHeat: function() {
		let self = this;
		let checkDigiHeat = function() {
			if('NO_DIGIHEAT' === self.options.digiHeatModel.get('digiHeatMode')) {
				self.detachChildView('digiHeat');
			} else {
				if(!self.getRegion('digiHeat').hasView()){
					let controlDigiHeatView = new ControlDigiHeatView( _.extend( self.options, {
						model: self.options.digiHeatModel || channel.request( 'digiHeatModes' ).get( self.options.unit.get('id')),
					} ) );
					self.showChildView( 'digiHeat', controlDigiHeatView, false );
				}
			}
		};
		self.options.digiHeatModel.on('sync', checkDigiHeat);
		checkDigiHeat(this.options.digiHeatModel);
	},

	/**
	 * Creates and attaches the alarm module.
	 * @private
	 * @void
	 */
	_showAlarm: function () {
		let controlAlarmView = new ControlAlarmView( _.extend( this.options, {
			model: new Bb.Model( {
				id                         : this.model.get( 'id' ),
				transientSubscription      : 1,
				alarmState                 : 'OFF',
				generalAlarmState          : 'ON',
				generalAlarmFollowMainState: 'OFF'
			} ),
			state: this._getModuleState( 'alarm' ),
		} ) );
		this.showChildView( 'alarm', controlAlarmView );
	},
	
	/**
	 * Creates and attaches the notifications module.
	 * @private
	 * @void
	 */
	_showNotifications: function () {
		let hideSticky = 'control:notifications' === this.options.subView;

		let controlNotificationsView = new ControlNotificationsView( _.extend( this.options, {
			state     : this._getModuleState( 'notifications' ),
			model     : this.options.notificationHolderModel || channel.request('notificationHolders').get(this.options.unit.get('id')),
			unitId    : this.model.get( 'id' ),
			hideSticky
		} ) );

		this.showChildView( 'notifications', controlNotificationsView );
	},
	
	_showPickupTimes: function () {
		let controlPickupTimesView = new ControlPickupTimesView( _.extend( this.options, {
			state     : this._getModuleState( 'pickupTimes' ),
			model: this.options.pickupTimeModel || channel.request( 'pickupTimes').get( this.options.unit.get('id')),
		}));
		
		this.showChildView('pickupTimes', controlPickupTimesView);
	},

	_showCalendar: function () {
		let controlCalendarView = new ControlCalendarEntriesView( _.extend( this.options, {
			model: this.options.calendarModel || channel.request( 'calendars').get( this.options.unit.get('id')),
			state: this._getModuleState( 'calendar' ),
		}));
		
		this.showChildView('calendar', controlCalendarView);
	},

	_showNotes: function () {
		let controlNoteView = new ControlNoteView( _.extend( this.options, {
			model: this.options.unit,
		}));
		this.showChildView('notes', controlNoteView);
	},

	_showSecurity: function(){
		let controlSecurityView = new ControlSecurityView( _.extend( this.options, {
			state     : this._getModuleState( 'security' ),
			model: this.options.securityModel || channel.request('securitys').get( this.options.unit.get('id')),
		}));
		this.showChildView('security', controlSecurityView);
	},
	
	_showWarmupStates: function () {

		let controlWarmupStatesView = new ControlWarmupStatesView( _.extend( this.options, {
			model: this.options.warmupStateModel || channel.request( 'warmupStates' ).get( this.options.unit.get('id')),
		}));

		this.showChildView('warmupStates', controlWarmupStatesView);
	},

	_showGenericStates: function () {
		let controlGenericStatesView = new ControlGenericStatesView( _.extend( this.options, {
			model: this.options.genericStateModel || channel.request( 'genericStates' ).get( this.options.unit.get('id')),
		}));

		this.showChildView('genericStates', controlGenericStatesView);
	},
	
	_showHomeAlerts: function () {
		let controlHomeAlertsView = new ControlHomeAlertsView( _.extend( this.options, {
			model: { temperatureModel: (this.options.temperatureAlertModel || channel.request( 'temperatureAlerts' ).get( this.options.unit.get('id'))),
					 batteryModel: (this.options.batteryAlertModel || channel.request( 'batteryAlerts' ).get( this.options.unit.get('id'))),
				     powerModel: (this.options.powerAlertModel || channel.request( 'powerAlerts' ).get( this.options.unit.get('id'))),
			},
		}));
		
		this.showChildView('homeAlerts', controlHomeAlertsView);
	},

	_showGeneralAlarmInputs: function () {
		let controlGpaiView = new ControlGpaiView( _.extend( this.options, {
			model: { followMainAlarmModel: (this.options.followMainAlarmSwitchModel || channel.request( 'followMainAlarms' ).get( this.options.unit.get('id'))),
				     generalAlarmInputModel: (this.options.generalAlarmInputSwitchModel || channel.request( 'generalAlarmInputs' ).get( this.options.unit.get('id'))),
			},
			settingsHome : channel.request('settingsHomes').get(this.options.unit.get('transientSettingsHome')) || new SettingsHome( {unit: this.options.unit.get('id')} )
		}));

		this.showChildView('generalAlarms', controlGpaiView);
	},

	_showAccessories: function () {
		let controlAccessoriesView = new ControlAccessoriesView( _.extend( this.options, {
			model : this.options.accessoriesHolderModel || channel.request( 'accessoriesHolders').get( this.options.unit.get('id')),
			state: this._getModuleState( 'accessories' ),
		}));

		this.showChildView('accessories', controlAccessoriesView);
	},

	_showDayAndNight: function () {
		let controlDayAndNightView = new ControlDayAndNightView( _.extend( this.options, {
			state : this._getModuleState( 'dayAndNight' ),
			model : this.options.dayAndNightModel || channel.request( 'dayAndNightSettings').get( this.options.unit.get('id')),
		}));
		
		this.showChildView('dayAndNight', controlDayAndNightView);
	},

	/**
	 * Creates and attaches the details module.
	 * @private
	 * @void
	 */
	_showDetails: function () {
		let controlDetailsView = new ControlDetailsView( _.extend( this.options, {
			model: this.options.unit,
			state: this._getModuleState( 'details' ),
		} ) );
		this.showChildView( 'details', controlDetailsView );
	},
	
	/**
	 * Creates and attaches the technical module.
	 * !TODO: Talk to support on weather this should be it's own module, or placed into the details module.
	 * @private
	 * @void
	 */
	_showTechnical: function () {
		
		let unitTechnical        = new UnitTechnical( {
			id: this.options.unit.get( 'id' ),
		} );
		this.listenToOnce( unitTechnical, 'sync', function ( model ) {
			let controlTechnicalView = new ControlTechnicalView( _.extend( this.options, {
				model: model,
				state: this._getModuleState( 'technical' )
			} ) );
			this.showChildView( 'technical', controlTechnicalView );
		} );
		unitTechnical.fetch();
	},
	
	/**
	 * Creates and attaches the settings module.
	 * @private
	 * @void
	 */
	_showSettings: function () {
		let controlSettingsView = new ControlSettingsView( _.extend( this.options, {
			model : this.options.unit,
			state: this._getModuleState( 'settings' ),
		} ) );
		this.showChildView( 'settings', controlSettingsView );
	},
	
	/**
	 * Creates and attaches the weather module.
	 * @private
	 * @void
	 */
	_showWeather: function () {
		if ( this.model.get( 'transientSettingsHome' ) && channel.request( 'settingsHomes' ).get( this.model.get( 'transientSettingsHome' ) ).get( 'location' ) ) {
			if ( this.options.forecasts ) {
				let self = this;
				
				let controlWeatherView = new ControlWeatherView( _.extend( this.options, {
					collection: this.options.forecasts,
					state     : self._getModuleState( 'weather' ),
				} ) );
				self.showChildView( 'weather', controlWeatherView );
			}
		} else {
			let controlWeatherError = new ControlModuleErrorView( _.extend( this.options, {
				title  : T.tc( 'ControlModuleError', 'Weather' ),
				message: T.tc( 'ControlModuleError', 'To see the weather you need to set a location. You can set the location through the settings menu' )
			} ) );
			this.showChildView( 'weather', controlWeatherError );
		}
	},
	
	/**
	 * Creates and attaches the finder module.
	 * @private
	 * @void
	 */
	_showFinder: function(){
		let finder = new ControlFinderView( _.extend( this.options, {
			model: this.options.finderModel || channel.request( 'finders' ).get( this.options.unit.get('id')),
			state: this._getModuleState( 'finder' )
		} ) );
		this.showChildView( 'finder', finder );
		// Create A ControlFin
		
	},
	
	/**
	 * Creates and attaches the map module.
	 * @private
	 * @void
	 */
	_showMap: function () {
		let map = new ControlMapView( _.extend( this.options, {
			model: this.options.unit,
			state: this._getModuleState( 'map' )
		} ) );
		this.showChildView( 'map', map );
	},
	
	showProgressBar: function(){
		if(!this.getRegion('progress').hasView()){
			let loadingBar = _.template('<div class="progress indeterminate">' +
										'<div class="bar progress-bar"></div>' +
										'<div class="bar buffer-bar"></div>' +
										'<div class="bar aux-bar"></div>' +
										'</div>');
			this.showChildView( 'progress', loadingBar);
		}
	},
	
	emptyCommunicationRegions: function () {
		this.getRegion( 'accessories').empty();
		this.getRegion( 'general' ).empty();
		this.getRegion( 'switches' ).empty();
		this.getRegion( 'zones' ).empty();
		this.getRegion( 'alarm' ).empty();
		this.getRegion( 'pickupTimes' ).empty();
		this.getRegion( 'calendar' ).empty();
		this.getRegion( 'dayAndNight' ).empty();
		this.getRegion( 'digiHeat' ).empty();
		this.getRegion( 'finder' ).empty();
		this.getRegion( 'homeAlerts' ).empty();
		this.getRegion( 'generalAlarms' ).empty();
		this.getRegion( 'genericStates' ).empty();
		this.getRegion( 'security' ).empty();
		this.getRegion( 'warmupStates' ).empty();
	},
	
	emptyNonCommunicationRegions: function () {
		this.getRegion( 'notifications' ).empty();
		this.getRegion( 'notes' ).empty();
		this.getRegion( 'details' ).empty();
		this.getRegion( 'technical' ).empty();
		this.getRegion( 'settings' ).empty();
		this.getRegion( 'weather' ).empty();
		this.getRegion( 'notes' ).empty();
		this.getRegion( 'notes' ).empty();
	},
	
	hideStickyElements: function () {
		this.hideElement( 'notes' );
		this.hideElement( 'digiHeat' );
		this.hideElement( 'switches' );
		this.hideElement( 'generalAlarms' );
	},
	
	showStickyElements: function () {
		this.showElement( 'notes' );
		this.showElement( 'digiHeat' );
		this.showElement( 'switches' );
		this.showElement( 'generalAlarms' );
	},
	
	isSettingModule: function (){
		if ( 'control:alarmSettings' === this.options.subView) {
			return true;
		}
		if ( 'control:dayAndNight' === this.options.subView ) {
			return true;
		}
		if ( 'control:gpai' === this.options.subView ) {
			return true;
		}
		return false;
	}
	
} );

export default ControlContainer;
